import { Component, Inject, Input } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { SubmitListingSyndicationRequest, SyndicationApiService } from '@vendasta/listing-syndication';
import { Observable, Subscription } from 'rxjs';
import { AGIDTOKEN, SyncError } from '../../../local-seo';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ListingSyncService } from '../../listing-sync.service';
import { SyncStatus } from '@vendasta/listing-products';

@Component({
  selector: 'local-seo-listing-sidebar-errors',
  templateUrl: './listing-sidebar-errors.component.html',
  styleUrl: './listing-sidebar-errors.component.scss',
  standalone: false,
})
export class ListingSidebarErrorsComponent {
  @Input() sourceName: string;
  @Input() sourceId: number;
  @Input() errors: SyncError[];
  @Input() canForceSync: boolean;

  subscriptions: Subscription[] = [];

  constructor(
    @Inject(AGIDTOKEN) private agid$: Observable<string>,
    private listingSyndicationService: SyndicationApiService,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private listingSyncService: ListingSyncService,
  ) {}

  forceSync(): void {
    this.subscriptions.push(
      this.agid$
        .pipe(
          switchMap((agid) =>
            this.listingSyndicationService.submitListingSyndication(
              new SubmitListingSyndicationRequest({
                accountGroupId: agid,
                sourceIds: [this.sourceId],
                trigger: 'local seo force sync ui',
                force: true,
              }),
            ),
          ),
        )
        .subscribe(() => {
          this.snackBar.open(this.translate.instant('LISTING_SYNC.SOURCE_MENU.FORCE_SYNC_SUCCESS'), '', {
            duration: 5000,
          });
          this.listingSyncService.updateSyncStatus(this.sourceId, SyncStatus.SYNC_STATUS_SYNCING, true);
        }),
    );
  }
}
